module.exports = __webpack_public_path__ + "img/printer.cb409233.svg";